/**
 * Ejemplos numéricos (10% off) para explicar cada estrategia en el CMS.
 */

const EXAMPLE_DISCOUNT = 10;

const savingBadge = (percent, highlight = false) => ({
    text: `${percent}% off`,
    highlight,
});

export const STRATEGY_EXAMPLES = {
    current_price: {
        intro:
            'Con un 10% de descuento: solo baja el precio de venta. No aparece precio tachado en la vitrina.',
        scenarios: [
            {
                title: 'Ejemplo',
                rows: [
                    { label: 'Antes', price: '$100', compareAt: '—', saving: '—' },
                    {
                        label: 'Después',
                        price: '$90',
                        compareAt: '—',
                        saving: savingBadge(EXAMPLE_DISCOUNT, true),
                    },
                ],
            },
        ],
    },
    price_swap: {
        intro:
            'Con un 10% de descuento: el precio de venta actual se muestra tachado y el nuevo precio es el precio con descuento.',
        scenarios: [
            {
                title: 'Ejemplo',
                rows: [
                    { label: 'Antes', price: '$100', compareAt: '—', saving: '—' },
                    {
                        label: 'Después',
                        price: '$90',
                        compareAt: '$100',
                        saving: savingBadge(EXAMPLE_DISCOUNT, true),
                    },
                ],
            },
        ],
    },
};

export const STRATEGY_GLOSSARY = [
    {
        term: 'Precio de venta',
        definition: 'Es el precio que paga el cliente en tu tienda.',
    },
    {
        term: 'Precio tachado',
        definition:
            'Precio anterior más alto que se muestra rayado junto al precio de venta (solo en la opción “Oferta con precio tachado”).',
    },
];
